// extracted by mini-css-extract-plugin
export default {"mainArticleContainer":"Eula_mainArticleContainer__pRU+h","headerStyle":"Eula_headerStyle__jkgl3","ContentStyle":"Eula_ContentStyle__PvIuk","eulaText":"Eula_eulaText__jos01"};